// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__9b2LE","rootCenter":"LoadMoreObserver_rootCenter__1S6Ei","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1EPI7"};